import { Auth } from "aws-amplify";
import awsconfig from "../aws-exports";
const config = require("Config");

let finalRedirectUrl;

// generate method to refresh the token using Auth.currentSession() and invoke /session endpoint    
const refreshSession = async (redirectUrl) => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    //get session attribute from current user
    const signInUserSession = user.signInUserSession;
    let accessToken = signInUserSession.accessToken.jwtToken;
    let refreshToken = signInUserSession.refreshToken.token;
    let idToken = signInUserSession.idToken.jwtToken

    var url = redirectUrl || `${config.brightPathUrl}`;

    const path = '/session';
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify({ redirectUrl: url, clientId: config.appClientId, accessToken: accessToken, refreshToken: refreshToken, idToken: idToken })
    };
    let res = await fetch((config.apiHost + path), requestOptions);
    if (res.status !== 200) {
        await Auth.signOut();
        return;
    }
    let response = await res.json();
    document.cookie = "sessionToken=" + JSON.stringify(response.sessionToken) + "; domain=.youscience.com; path=/";
    return res;
}

export const getCurrentTOS = async (props) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };
    const path = '/v2/public/termsOfUse/current';
    let res = await fetch((config.gusHostName + path), requestOptions);
    let resp = await res.json();
    return resp;
};

const getProviderClients = async (providerType) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };
    const path = `/api/v1/cognito/providers?type=${providerType}`;
    let res = await fetch((config.apiHost + path), requestOptions);
    let resp = await res.json();
    return resp;
};

export const getOffice365Clients = async (props) => {
    return getProviderClients('M365');
};

export const getSkywardClients = async (props) => {
    return getProviderClients('Skyward');
};

export const generateSession = async (props) => {

    if (finalRedirectUrl)
        return finalRedirectUrl;

    let user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    if (awsconfig.skipUserEmailVerification !== true && user.attributes?.email_verified === false && 
        user.username.indexOf("_") === -1) {
        await Auth.signOut();
        return '/';
    }
    let signInUserSession = user.signInUserSession;
    var defaultRedirectUrl = `${config.brightPathUrl}`;

    /*   let tokenDecoded = jwt_decode(signInUserSession.idToken.jwtToken);
      if (tokenDecoded && tokenDecoded.provider == 'ClassLink' && config.gusServiceUrl)
          defaultRedirectUrl = `${config.discoveryServiceUrl.replace("login", "apps").replace("api", "apps")}`; */

    if (sessionStorage.getItem("link_acc_token"))
        defaultRedirectUrl = defaultRedirectUrl + "?linktoken=" + sessionStorage.getItem("link_acc_token")

    var url = sessionStorage.getItem("redirectUrl") || defaultRedirectUrl;
    let accessToken = signInUserSession.accessToken.jwtToken;
    let refreshToken = signInUserSession.refreshToken.token;
    let idToken = signInUserSession.idToken.jwtToken
    let body = { redirectUrl: url, clientId: config.appClientId, accessToken: accessToken, refreshToken: refreshToken, idToken: idToken }

    const path = '/session';
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${body.accessToken}` },
        body: JSON.stringify(body)
    };
    let res = await fetch((config.apiHost + path), requestOptions);

    if (res.status === 403)
        res = await refreshSession(url);

    let response = await res.json();

    if (response.location) {
        let url = new URL(response.location);
        let urlsp = url.searchParams;

        if (props.user.attributes["custom:activation_token"])
            urlsp.set("activation_token", props.user.attributes["custom:activation_token"])

        finalRedirectUrl = encodeURI(url.toString());
        document.cookie = "sessionToken=" + JSON.stringify(response.sessionToken) + "; domain=.youscience.com; path=/; SameSite=Strict; Secure";
        return finalRedirectUrl
    } else {
        return { error: true, response };
    }
}

// generate a promise method to signout user using Auth.signOut() and invoke /signout endpoint
export const signOut = async (redirectUrl, relativeRedirectUrl) => {

    let path = '/signout';
    if (redirectUrl) {
        path = path + '?redirectUrl=' + encodeURIComponent(redirectUrl);
    }

    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let res = await fetch((config.apiHost + path), requestOptions);
    let resp = await res.json();
    if (res.status === 200 && resp.location) {
        window.location = resp.location;
    }
    else if (relativeRedirectUrl)
        window.location = relativeRedirectUrl;
    else {
        window.location.href = '/';
    }
    return resp;
}

